import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PushNotificationService } from 'src/app/shared/services/push-notification/push-notification.service';

@Component({
  selector: 'app-modal-notificacao-obras',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal-notificacao-obras.component.html',
  styleUrls: ['./modal-notificacao-obras.component.scss'],
})
export class ModalNotificacaoObrasComponent implements OnInit {
  showBrowserInstruction = false;
  errorMsg = '';
  isLoading = false;

  constructor(
    public bsModalRef: BsModalRef,
    private _pushService: PushNotificationService,
  ) {}

  ngOnInit(): void {}

  async solicitarNotificacoes(): Promise<void> {
    this.isLoading = true;
    try {
      await this._pushService.requestPermission();
      this.showBrowserInstruction = true;

      setTimeout(() => {
        this.bsModalRef.hide();
      }, 3000);
    } catch (error) {
      console.error('Erro solicitando permissão:', error);
      this.bsModalRef.hide();
    } finally {
      this.isLoading = false;
    }
  }

  fecharModal(): void {
    localStorage.setItem(
      'notificationPromptDismissedDateLong',
      new Date().toISOString(),
    );
    this.bsModalRef.hide();
  }

  fecharModalX(): void {
    localStorage.setItem(
      'notificationPromptDismissedDate',
      new Date().toISOString(),
    );
    this.bsModalRef.hide();
  }
}
